

















import {Component, Prop, Vue} from 'vue-property-decorator';
import NotificationsButton from '@/components/notifications-button/notifications-button.vue';
import {IKeyValues} from '@/interfaces/key-value-interface';
import {i18nMixin} from '@/modules/neodash/mixins';
import HomeButtonComponent from '@/components/home-button/home-button.component.vue';

@Component({
  name: 'ReportAppBar',
  components: {
    HomeButtonComponent,
    NotificationsButton
  }
})
export default class ReportAppBar extends Vue {
  public readonly translate = i18nMixin.methods.i18n;

  @Prop({required: true})
  keyNameReport: string;

  @Prop({required: true})
  labelFilters: IKeyValues;
}
